/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} View_CardsInputs */

const cs_view_cards = /** @type {(inputs: View_CardsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Karty`)
};

const en_view_cards = /** @type {(inputs: View_CardsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cards`)
};

/**
* | output |
* | --- |
* | "Cards" |
*
* @param {View_CardsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const view_cards = /** @type {((inputs?: View_CardsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<View_CardsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_view_cards(inputs)
	return cs_view_cards(inputs)
});